import { runInAction } from 'mobx';
import { getMember } from '../../../selectors/member/get-member';
import { defaultTemporaryLoyaltyDomainState } from '../../../temporary-store/state';
import { temporaryLoyaltyDomainStore } from '../../../temporary-store/store';
import { assertIsMemberSignedIn } from '../../../utils/assert-is-member-signed-in';
export const clearMemberTransactions = () => {
    assertIsMemberSignedIn(getMember(), 'Cannot clear member transactions');
    runInAction(() => {
        temporaryLoyaltyDomainStore.data.memberTransactions = defaultTemporaryLoyaltyDomainState.memberTransactions;
    });
};
